import { jsx as _jsx } from "react/jsx-runtime";
import { createBrowserRouter } from 'react-router-dom';
import AdminLayout from './components/AdminLayout';
import Layout from './components/Layout';
import ProductRoute from './components/ProductRoute';
import ProtectedRoute from './components/ProtectedRoute';
import AboutPage from './pages/AboutPage';
import AdminDashboard from './pages/admin/AdminDashboard';
import OrderDashboard from './pages/admin/OrderDashboard';
import AdminOrderDetail from './pages/admin/OrderDetail';
import ProductEdit from './pages/admin/ProductEdit';
import ProductManager from './pages/admin/ProductManager';
import Wholesalers from './pages/admin/Wholesalers';
import CartPage from './pages/CartPage';
import CheckoutConfirmationPage from './pages/CheckoutConfirmationPage';
import CheckoutPage from './pages/CheckoutPage';
import ContactPage from './pages/ContactPage';
import LandingPage from './pages/LandingPage';
import Login from './pages/Login';
import NotFound from './pages/NotFound';
import OrderDetailPage from './pages/OrderDetailPage';
import OrderHistoryPage from './pages/OrderHistoryPage';
import OrderLookupPage from './pages/OrderLookupPage';
import ShopPage from './pages/ShopPage';
import { PATHS, ROUTES } from './routes';
const router = createBrowserRouter([
    {
        path: ROUTES.login,
        element: /*#__PURE__*/ _jsx(Login, {})
    },
    {
        path: '/',
        element: /*#__PURE__*/ _jsx(Layout, {}),
        children: [
            {
                index: true,
                element: /*#__PURE__*/ _jsx(LandingPage, {})
            },
            {
                path: PATHS.shop,
                element: /*#__PURE__*/ _jsx(ShopPage, {})
            },
            {
                path: PATHS.product,
                element: /*#__PURE__*/ _jsx(ProductRoute, {})
            },
            {
                path: PATHS.about,
                element: /*#__PURE__*/ _jsx(AboutPage, {})
            },
            {
                path: PATHS.contact,
                element: /*#__PURE__*/ _jsx(ContactPage, {})
            },
            {
                path: PATHS.cart,
                element: /*#__PURE__*/ _jsx(CartPage, {})
            },
            {
                path: PATHS.checkout,
                element: /*#__PURE__*/ _jsx(CheckoutPage, {})
            },
            {
                path: PATHS.checkoutConfirmation,
                element: /*#__PURE__*/ _jsx(CheckoutConfirmationPage, {})
            },
            {
                path: PATHS.orderLookup,
                element: /*#__PURE__*/ _jsx(OrderLookupPage, {})
            },
            {
                path: PATHS.orderDetail,
                element: /*#__PURE__*/ _jsx(OrderDetailPage, {})
            },
            {
                element: /*#__PURE__*/ _jsx(ProtectedRoute, {}),
                children: [
                    {
                        path: PATHS.accountOrders,
                        element: /*#__PURE__*/ _jsx(OrderHistoryPage, {})
                    }
                ]
            },
            {
                path: '*',
                element: /*#__PURE__*/ _jsx(NotFound, {})
            }
        ]
    },
    {
        element: /*#__PURE__*/ _jsx(ProtectedRoute, {}),
        children: [
            {
                path: PATHS.admin,
                element: /*#__PURE__*/ _jsx(AdminLayout, {}),
                children: [
                    {
                        index: true,
                        element: /*#__PURE__*/ _jsx(AdminDashboard, {})
                    },
                    {
                        path: 'products',
                        element: /*#__PURE__*/ _jsx(ProductManager, {})
                    },
                    {
                        path: 'products/new',
                        element: /*#__PURE__*/ _jsx(ProductEdit, {})
                    },
                    {
                        path: 'products/:productId',
                        element: /*#__PURE__*/ _jsx(ProductEdit, {})
                    },
                    {
                        path: 'orders',
                        element: /*#__PURE__*/ _jsx(OrderDashboard, {})
                    },
                    {
                        path: 'orders/:orderId',
                        element: /*#__PURE__*/ _jsx(AdminOrderDetail, {})
                    },
                    {
                        path: 'wholesalers',
                        element: /*#__PURE__*/ _jsx(Wholesalers, {})
                    }
                ]
            }
        ]
    }
]);
export default router;
